/**
 * Date utility functions
 */

export const normalizeDate = (dateStr: string): Date => {
  if (!dateStr) {
    return new Date(NaN); // Invalid date
  }
  
  // Parse YYYY-MM-DD format without timezone conversion
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[2], 10);
    return new Date(year, month, day);
  }
  
  // Fallback to standard parsing
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    console.warn('Invalid date format:', dateStr);
    return new Date(NaN);
  }
  
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

